export const vendor = Object.freeze({
	googleTagManager: 'GTM-TR3Q62P',
	googleAnalytics: 'UA-763513-3',
	googleReCaptcha: '6Lf5OPEqAAAAAHygcbiUxmXrPdMtISsTzqNNA3va'
})
